import React, { useContext, useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { PhoneCall, Edit2, Plus, Mail, Smartphone } from "react-feather";
import { AddShippingAddressModal } from "./AddShippingAddressModal";
import { AddContactPersonModal } from "./AddContactPersonModal";
import { EditContactPersonModal } from "./EditContactPersonModal";
import {
  capitalizeFirstLetter,
  amountFormatter,
  dateFormatter,
  setActiveMenu,
  getStatusPOClass,
} from "../../constants/utils";
import { FormattedMessage } from "react-intl";
import { EditBillingAddressModal } from "./EditBillingAddressModal";
import { USER_DETAILS } from "../../constants/const";
import { MENUITEMS } from "../../constants/menu";
import { UIContext } from "../../helper/UIContext";

export function DefaultVendorView({
  vendorDetails,
  id,
  recentFivePO,
  isLoading,
  recentFiveFulfilledPO,
  handleUpdateSingleVendorDetails,
}) {
  const history = useHistory();
  const uiContext = useContext(UIContext);
  const [isOpenAddBillingAddressModal, setOpenAddBillingAddressModal] =
    useState(false);
  const [isOpenAddShippingAddressModal, setOpenAddShippingAddressModal] =
    useState(false);
  const [isOpenAddContactPersonModal, setOpenAddContactPersonModal] =
    useState(false);
  const [isOpenEditContactPersonModal, setOpenEditContactPersonModal] =
    useState(false);
  const [selectedContactPerson, setSelectedContactPerson] = useState({});
  const [mainmenu, setMainMenu] = useState(MENUITEMS);

  const addBillingAddressModalShow = () => {
    setOpenAddBillingAddressModal(true);
  };

  const addBillingAddressModalHide = () => {
    setOpenAddBillingAddressModal(false);
  };

  const addShippingAddressModalShow = () => {
    setOpenAddShippingAddressModal(true);
  };

  const addShippingAddressModalHide = () => {
    setOpenAddShippingAddressModal(false);
  };
  const addContactPersonModalShow = () => {
    setOpenAddContactPersonModal(true);
  };

  const addContactPersonModalHide = () => {
    setOpenAddContactPersonModal(false);
  };

  const editContactPersonModalShow = () => {
    setOpenEditContactPersonModal(true);
  };

  const editContactPersonModalHide = () => {
    setOpenEditContactPersonModal(false);
  };

  const renderContactName = (contact) => {
    const { first_name, last_name } = contact;
    let name = first_name ? first_name : "";
    let space = " ";
    const lastName = last_name ? last_name : "";
    if (last_name) name = name.concat(space, lastName);
    return capitalizeFirstLetter(name);
  };

  const handleCloseOfEditBillingAddressVendorModal = () => {
    handleUpdateSingleVendorDetails();
    addBillingAddressModalHide();
  };

  const handleCloseOfEditShippingAddressVendorModal = () => {
    handleUpdateSingleVendorDetails();
    addShippingAddressModalHide();
  };

  const handleCloseOfAddNewContactPersonVendorModal = () => {
    handleUpdateSingleVendorDetails();
    addContactPersonModalHide();
  };

  const handleCloseOfEditContactPersonVendorModal = () => {
    handleUpdateSingleVendorDetails();
    editContactPersonModalHide();
  };

  const onClickChangeRoute = (routePath) => {
    setMainMenu(setActiveMenu(mainmenu, routePath));
    uiContext.setCurrentPath(routePath);
    history.push(routePath);
  };

  const renderStatusName = (purchaseorderstatus) => {
    const { name: status } = purchaseorderstatus || {};
    return (
      <span
        className={`${getStatusPOClass(
          status
        )} status-color text-capitalize cursor-pointer`}
      >
        {status ? status : "-"}
      </span>
    );
  };

  const userDetails = JSON.parse(localStorage.getItem(USER_DETAILS));
  const { role } = userDetails || {};
  const { name: userRole } = role || {};

  return (
    <>
      <div className="">
        <div className="highlighted-row">
          <div className="d-flex align-items-start align-items-md-center justify-content-between flex-column flex-md-row">
            <div className="left">
              <h3 className="modal-title mb-2">
                {capitalizeFirstLetter(vendorDetails?.contact_name)}
              </h3>
              <div className="text-dark mb-2">
                <Mail size={12} className="text-dark mr-2" />
                {vendorDetails?.email ? vendorDetails?.email : "-"}
              </div>
              <div className="text-dark mb-2">
                <Smartphone size={12} className="text-dark mr-2" />
                <span className="ltr-direction">
                  {vendorDetails?.mobile_number
                    ? vendorDetails?.mobile_number
                    : "-"}
                </span>
              </div>
              <div className="text-dark mb-2">
                <PhoneCall size={12} className="text-dark mr-2" />
                <span className="ltr-direction">
                  {vendorDetails?.phone_number
                    ? vendorDetails?.phone_number
                    : "-"}
                </span>
              </div>
            </div>
            <div className="right">
              <h3 className="text-primary f-w-900 page-title text-right">
                <small className="text-dark fs-14">
                  {/* {vendorDetails && vendorDetails.outstanding_products && (
                    
                  )} */}
                  <FormattedMessage id="TITLE.TOTAL.OUTSTANDING.PRODUCTS" />
                </small>
                <br />
                {vendorDetails?.outstanding_products}
              </h3>
              <h5 className="fs-14 text-right text-dark">
                {/* {vendorDetails && vendorDetails.product_quantity_till_date && (
                
                )} */}
                <FormattedMessage id="TITLE.PRODUCT.QUANTITY.RECEIVED.TILL.DATE" />
                <br />
                <span className="f-w-900 fs-16 text-primary">
                  {vendorDetails?.product_quantity_till_date}
                </span>
              </h5>
            </div>
          </div>
        </div>
        <div className="view-body">
          <Row className="mb-5">
            <Col md={12}>
              <div>
                <div className="text-dark mb-2 fs-16 text-black f-w-600">
                  <FormattedMessage id="TITLE.ADDRESS" />
                </div>
                <Row>
                  <Col md={6}>
                    <div className="text-dark f-w-600">
                      <FormattedMessage id="TITLE.BILLING.ADDRESS" />
                      <Edit2
                        className="cursor-pointer ml-2 text-dark"
                        size={14}
                        onClick={() => addBillingAddressModalShow()}
                      />
                    </div>
                    <div className="mb-2 mt-2">
                      {capitalizeFirstLetter(
                        vendorDetails?.billingaddress?.building_no
                      )}
                    </div>
                    <div className="mb-2">
                      {capitalizeFirstLetter(
                        vendorDetails?.billingaddress?.city?.name
                      )}
                    </div>
                    <div className="mb-2">
                      {capitalizeFirstLetter(
                        vendorDetails?.billingaddress?.country?.name
                      )}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="text-dark f-w-600">
                      <FormattedMessage id="TITLE.SHIPPING.ADDRESS" />
                      <Edit2
                        className="cursor-pointer ml-2 text-dark"
                        size={14}
                        onClick={() => addShippingAddressModalShow()}
                      />
                    </div>
                    <div className="mb-2 mt-2">
                      {capitalizeFirstLetter(
                        vendorDetails?.shippingaddress?.building_no
                      )}
                    </div>
                    <div className="mb-2">
                      {capitalizeFirstLetter(
                        vendorDetails?.shippingaddress?.city?.name
                      )}
                    </div>
                    <div className="mb-2">
                      {capitalizeFirstLetter(
                        vendorDetails?.shippingaddress?.country?.name
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="address">
                <div className="text-black f-w-600">
                  <FormattedMessage id="TITLE.OTHER.DETAILS" />
                </div>
                <Row>
                  <Col xs={6}>
                    <h6 className="text-dark">
                      <FormattedMessage id="TITLE.CURRENCY.CODE" />
                    </h6>
                  </Col>
                  <Col xs={6} className="text-dark">
                    {vendorDetails?.currency}
                  </Col>
                </Row>
                <Row>
                  <Col xs={6}>
                    <h6 className="text-dark">
                      <FormattedMessage id="TITLE.REMARKS" />
                    </h6>
                  </Col>
                  <Col xs={6} className="text-dark">
                    {vendorDetails?.remarks}
                  </Col>
                </Row>
              </div>
              <div className="address border-top mt-3">
                <Row>
                  <Col xs={6}>
                    <h6 className="text-black f-w-600 fs-16">
                      <FormattedMessage id="TITLE.CONTACT.PERSONS" />
                    </h6>
                  </Col>
                  <Col xs={6} className="text-right">
                    <Plus
                      className="cursor-pointer text-dark"
                      size={16}
                      onClick={() => addContactPersonModalShow()}
                    />
                  </Col>
                </Row>
                <Row>
                  {vendorDetails &&
                    vendorDetails.contact_person &&
                    vendorDetails.contact_person.map((contact, index) => {
                      return (
                        <Col md={4} key={index}>
                          <div className="mt-2">
                            {contact?.first_name && (
                              <h3 className="fs-14 f-w-900 text-black">
                                {renderContactName(contact)}
                                <Edit2
                                  className="cursor-pointer ml-2 text-dark"
                                  size={14}
                                  onClick={() => {
                                    setSelectedContactPerson(contact);
                                    editContactPersonModalShow();
                                  }}
                                />
                              </h3>
                            )}
                            {contact?.email && (
                              <div className="text-dark mb-2">
                                <Mail size={12} className="text-dark mr-2" />
                                {contact?.email}
                              </div>
                            )}
                            {contact?.mobile && (
                              <div className="text-dark mb-2">
                                <Smartphone
                                  size={12}
                                  className="text-dark mr-2"
                                />
                                <span className="ltr-direction">
                                  {contact?.mobile}
                                </span>
                              </div>
                            )}
                            {contact?.phone && (
                              <div className="text-dark mb-2">
                                <PhoneCall
                                  size={12}
                                  className="text-dark mr-2"
                                />
                                <span className="ltr-direction">
                                  {contact?.phone}
                                </span>
                              </div>
                            )}
                          </div>
                        </Col>
                      );
                    })}
                </Row>
              </div>
            </Col>

            <Col md={12} className="mt-5">
              {userRole !== "Admin" && (
                <>
                  <h3 className="fs-16 mb-3 text-black f-w-900">
                    <FormattedMessage id="TITLE.OPEN.PURCHASE.ORDERS.RECENT.5" />
                  </h3>
                  <Table responsive className="viewpo-table table">
                    <thead>
                      <tr>
                        <th style={{ width: "50%" }} scope="col">
                          PO #
                        </th>
                        <th scope="col">
                          <FormattedMessage id="TITLE.DATE" />
                        </th>
                        <th scope="col">
                          <FormattedMessage id="TITLE.QUANTITY" />
                        </th>
                        <th scope="col">
                          <FormattedMessage id="TITLE.AMOUNT" />
                        </th>
                        <th scope="col">
                          <FormattedMessage id="TITLE.STATUS" />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {recentFivePO &&
                        recentFivePO.map((vendor, index) => {
                          return (
                            <tr
                              key={index}
                              className="cursor-pointer"
                              onClick={() => {
                                const path = `/inwards/view-po-details/${vendor?.id}`;
                                onClickChangeRoute(path);
                                window.scrollTo(0, 0);
                              }}
                            >
                              <td>
                                <span className="text-info">
                                  {vendor?.purchaseorder_number}
                                </span>
                              </td>
                              <td className="ltr-direction">
                                {dateFormatter(vendor.date)}
                              </td>
                              <td className="ltr-direction">
                                {vendor.totalquantity}
                              </td>
                              <td className="digits">
                                {amountFormatter(vendor?.totalamount)}
                              </td>
                              <td className="ltr-direction">
                                {renderStatusName(vendor?.purchaseorderstatus)}
                              </td>
                            </tr>
                          );
                        })}
                      {recentFivePO &&
                        recentFivePO.length === 0 &&
                        !isLoading && (
                          <>
                            <tr>
                              <td className="no-record" colSpan={5}>
                                {/* <Image
                              src={nodatafoundImage}
                              alt="No Data Found"
                              class="img-fluid"
                              style={{ maxHeight: "200px" }}
                            /> */}
                                <span className="d-block text-center">
                                  <FormattedMessage id="TITLE.NO.RECORDS.FOUND" />
                                </span>
                              </td>
                            </tr>
                          </>
                        )}{" "}
                    </tbody>
                  </Table>
                </>
              )}
            </Col>
            <Col md={12} className="mt-2">
              {userRole !== "Admin" && (
                <>
                  <h3 className="fs-16 mb-3 text-black f-w-900">
                    <FormattedMessage id="TITLE.FULFILLED.PURCHASE.ORDERS.RECENT.5" />
                  </h3>
                  <Table responsive className="viewpo-table table">
                    <thead>
                      <tr>
                        <th style={{ width: "50%" }} scope="col">
                          PO #
                        </th>
                        <th scope="col">
                          <FormattedMessage id="TITLE.DATE" />
                        </th>
                        <th scope="col">
                          <FormattedMessage id="TITLE.QUANTITY" />
                        </th>
                        <th scope="col">
                          <FormattedMessage id="TITLE.AMOUNT" />
                        </th>
                        <th scope="col">
                          <FormattedMessage id="TITLE.STATUS" />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {recentFiveFulfilledPO &&
                        recentFiveFulfilledPO.map((vendor, index) => {
                          return (
                            <tr
                              key={index}
                              className="cursor-pointer"
                              onClick={() => {
                                const path = `/inwards/view-po-details/${vendor?.id}`;
                                onClickChangeRoute(path);
                                window.scrollTo(0, 0);
                              }}
                            >
                              <td>
                                <span className="text-info">
                                  {vendor?.purchaseorder_number}
                                </span>
                              </td>
                              <td className="ltr-direction">
                                {dateFormatter(vendor.date)}
                              </td>
                              <td className="ltr-direction">
                                {vendor.totalquantity}
                              </td>
                              <td className="digits">
                                {amountFormatter(vendor?.totalamount)}
                              </td>
                              <td className="ltr-direction">
                                {renderStatusName(vendor?.purchaseorderstatus)}
                              </td>
                            </tr>
                          );
                        })}
                      {recentFiveFulfilledPO &&
                        recentFiveFulfilledPO.length === 0 &&
                        !isLoading && (
                          <>
                            <tr>
                              <td className="no-record" colSpan={5}>
                                <span className="d-block text-center">
                                  <FormattedMessage id="TITLE.NO.RECORDS.FOUND" />
                                </span>
                              </td>
                            </tr>
                          </>
                        )}{" "}
                    </tbody>
                  </Table>
                </>
              )}
            </Col>
          </Row>

          {isOpenAddBillingAddressModal && (
            <EditBillingAddressModal
              open={isOpenAddBillingAddressModal}
              onCloseModal={addBillingAddressModalHide}
              vendorDetails={vendorDetails}
              id={id}
              handleCloseOfEditBillingAddressVendorModal={
                handleCloseOfEditBillingAddressVendorModal
              }
            />
          )}

          {isOpenAddShippingAddressModal && (
            <AddShippingAddressModal
              open={isOpenAddShippingAddressModal}
              onCloseModal={addShippingAddressModalHide}
              vendorDetails={vendorDetails}
              id={id}
              handleCloseOfEditShippingAddressVendorModal={
                handleCloseOfEditShippingAddressVendorModal
              }
            />
          )}

          {isOpenAddContactPersonModal && (
            <AddContactPersonModal
              open={isOpenAddContactPersonModal}
              onCloseModal={addContactPersonModalHide}
              id={id}
              handleCloseOfAddNewContactPersonVendorModal={
                handleCloseOfAddNewContactPersonVendorModal
              }
            />
          )}

          {isOpenEditContactPersonModal && (
            <EditContactPersonModal
              open={isOpenEditContactPersonModal}
              onCloseModal={editContactPersonModalHide}
              id={id}
              selectedContactPerson={selectedContactPerson}
              handleCloseOfEditContactPersonVendorModal={
                handleCloseOfEditContactPersonVendorModal
              }
            />
          )}
        </div>
      </div>
    </>
  );
}

export default DefaultVendorView;
